<sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">
    <sc-flex-fitting-content [vertical]="true">
        <sc-padding>
            <sc-scroll-pane>
                <app-transport-documents-list [transportId]="transportId"
                    [forceReloadRequest]="forceRefreshSubject"></app-transport-documents-list>
            </sc-scroll-pane>
        </sc-padding>
    </sc-flex-fitting-content>
    <sc-content-spacer [vertical]="true"></sc-content-spacer>
    <div>
        <sc-flex [centered]="true">
            <app-transport-photo-button [transportId]="transportId"
                (onDocumentUploaded)="refreshDocuments()"></app-transport-photo-button>
        </sc-flex>
    </div>
</sc-flex>